const dataSaverActionTypes = {
    SET_SEARCH_STATE_FOR_ADVANCED_SEARCH: 'SET_SEARCH_STATE_FOR_ADVANCED_SEARCH',
    SET_OWNERS_LIST: 'SET_OWNERS_LIST',
    SET_ANALYSTS_LIST: 'SET_ANALYSTS_LIST',
    SET_USERS_LIST: 'SET_USERS_LIST',
    SET_NETWORK_DATA: 'SET_NETWORK_DATA',
    SET_NOTIF_QUERY_DATA: 'SET_NOTIF_QUERY_DATA'
};

export default dataSaverActionTypes;